<!-- @format -->

<script setup>
import client from '../utils/client'
import Column from './Column.vue'
import SmartPadding from './SmartPadding.vue'
let titleInfo = defineProps({
  title: String,
  withStatus: Boolean,
  titleColor: {
    type: String,
    default: 'black',
  },
  backImg: {
    type: String,
    default: 'https://cdn.hifunclub.com/companysite/mobile/icon_arrow_left_black_2x.png',
  },
  sticky: {
    type: Boolean,
    default: false,
  },
  onBack: {
    type: Function,
    default: () => {
      client.goBack()
    },
  },
})
document.title = titleInfo.title
</script>
<template>
  <Column style="z-index: 1; margin: 0" :class="{ sticky: titleInfo.sticky }">
    <SmartPadding v-if="titleInfo.withStatus"></SmartPadding>
    <div class="title">
      <img @click="onBack" :src="titleInfo.backImg" style="width: var(--24px); height: var(--24px)" />
      <span
        :style="{ color: titleInfo.titleColor }"
        style="font-size: var(--18px); min-width: 30vw; justify-self: center; text-align: center; display: inline-block">
        {{ titleInfo.title }}
      </span>
      <div style="width: var(--24px); height: var(--24px)">
        <slot></slot>
      </div>
    </div>
    <slot name="titleBottom"></slot>
  </Column>
</template>
<style scoped>
.title {
  padding: 0 var(--16px);
  width: 100vw;
  height: 11.733333333333333vw;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
}

.sticky {
  position: sticky;
  top: 0;
  left: 0;
}
</style>
